module.exports = "//cdn-staging.livechat-static.com/webapp/img/campaigns/intent-exploring-tooltip.png?c7e6300cee44ba47e3bfa369ed5aa925";